import { render, staticRenderFns } from "./purchase-return-settle-add-or-update.vue?vue&type=template&id=75f05fbc&scoped=true"
import script from "./purchase-return-settle-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchase-return-settle-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchase-return-settle-add-or-update.vue?vue&type=style&index=0&id=75f05fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f05fbc",
  null
  
)

export default component.exports